<template><div><h1>vue 全局公用函数</h1>
<p>如果你需要让一个工具函数在每个组件可用，可以把方法挂载到 <code>Vue.prototype</code>上。</p>
<h2>注册</h2>
<p><code>main.js</code> 中</p>
<pre class="hljs"><code>Vue.prototype.$method = <span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params"></span>) </span>{}
</code></pre>
<div class="tip">
<p>一般建议函数名使用 <code>$</code> 前缀。像 <code>vue-router</code> 的 <code>$route</code> 和 <code>$router</code>。</p>
</div>
<h2>使用</h2>
<p>那么组件代码里</p>
<pre class="hljs"><code><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  created () {
    <span class="hljs-keyword">this</span>.$method()
  }
}
</code></pre>
<h2>说明</h2>
<p>挂载到 <code>prototype</code> 上是为了方便组件内直接用 <code>this.$method</code> 来使用，你也可以直接用 <code>Vue.method</code>，这样同样可以全局使用，不过在组件内就需要再 import 一次 <code>Vue</code> 了。</p>
</div></template><script>
export default {
  head: {"title":"Vue 全局公用函数 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// vue-global-method-157.vue?90fbf066